<template>
  <div class="product-details">
    <base-message v-if="error" design="red">
      Erro ao retornar as informações dos produtos.
    </base-message>

    <div v-else v-for="(oItem, iItem) in items" :key="iItem" class="product">
      <!-- NOVO CABEÇALHO DE PRODUTO -->
      <div class="d-flex justify-between align-center mb_30">
        <base-input-spinner
          v-if="cart"
          :index="iItem"
          :quantity="oItem.quantity"
          @handleItemQuantity="handleItemQuantity"
        />
        <div v-else class="qty-no-cart">{{ oItem.quantity }}x</div>

        <div class="name-n-price">
          <div v-if="oItem.type === 'simple'" class="name-box">
            <p
              class="product-name"
              :title="`${categoryName(oItem)} - ${oItem.name}`"
            >
              {{ categoryName(oItem) }} - {{ oItem.name }}
            </p>
          </div>

          <div
            v-else-if="oItem.type === 'step' || oItem.type === 'drink'"
            class="name-box"
          >
            <p
              class="product-name"
              :title="`${categoryName(oItem)} - ${oItem.name}`"
            >
              {{ categoryName(oItem) }} - {{ oItem.name }}
            </p>
            <p class="product-size">{{ oItem.sizes[0].name }}</p>
          </div>

          <div v-else class="mx_15 name-box">
            <p
              class="product-name"
              :title="`${categoryName(oItem)} - ${oItem.items[0].name}`"
            >
              <span>{{ categoryName(oItem) }} </span>
              <span v-if="oItem.items.length === 1">{{
                ' - ' + oItem.items[0].name
              }}</span>
            </p>
            <p class="product-size">{{ oItem.name }}</p>
          </div>

          <p v-if="!(remove || []).includes(iItem)" class="product-price">
            {{ oItem.getPrice && Utils.convertMoney(oItem.getPrice()) }}
          </p>
          <p v-else @click="removeItem(iItem)" class="remove-btn">Excluir</p>
        </div>
      </div>

      <!-- Flavors -->
      <div
        class="mt_10"
        v-if="oItem.items.length > 1 && oItem.type === 'pizza'"
      >
        <div
          v-for="(oFlavor, iFlavor) in oItem.items"
          :key="iFlavor"
          class="mb_10"
        >
          <p class="product-label">
            <span v-if="oItem.items.length > 1">
              {{
                reduceFlavorFraction(
                  oFlavor.quantity,
                  getFlavorsQuantity(oItem.items)
                )
              }}
            </span>
            {{ oFlavor.name }}
          </p>
          <div
            v-if="
              oFlavor.extra_ingredients && oFlavor.extra_ingredients.length > 0
            "
          >
            <div
              v-for="(oExtra, iExtra) in oFlavor.extra_ingredients"
              :key="iExtra"
              class="label-itens mt_5"
            >
              <p><span class="mr_5">+</span>{{ `${oExtra.name}` }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Etapa -->
      <div v-if="oItem.items.length > 0 && oItem.type === 'step'">
        <div v-for="(oStep, iStep) in oItem.items" :key="iStep" class="mt_10">
          <p class="product-label">{{ oStep.name }}</p>
          <div
            v-for="(oOption, iOption) in oStep.items"
            :key="iOption"
            class="label-itens"
          >
            <p>
              {{ `${oOption.quantity > 1 ? oOption.quantity + 'x ' : ''}`
              }}{{ `${oOption.name}` }}
            </p>
            <p>
              ({{ oOption.getPrice && Utils.convertMoney(oOption.getPrice()) }})
            </p>
          </div>
        </div>
      </div>

      <!-- Tipo de massa -->
      <div class="mt_10" v-if="oItem.doughs && oItem.doughs.length > 0">
        <p class="product-label">{{ StringLanguage.dough }}</p>
        <div
          v-for="(oDough, iDough) in oItem.doughs"
          :key="iDough"
          class="label-itens"
        >
          <p>{{ `${oDough.name}` }}</p>
          <p>
            ({{ oDough.getPrice && Utils.convertMoney(oDough.getPrice()) }})
          </p>
        </div>
      </div>

      <!-- Extras -->
      <div
        class="mt_10"
        v-if="oItem.extra_ingredients && oItem.extra_ingredients.length > 0"
      >
        <p class="product-label">{{ StringLanguage.extraIngredient }}</p>
        <div
          v-for="(oExtra, iExtra) in oItem.extra_ingredients"
          :key="iExtra"
          class="label-itens"
        >
          <p>{{ `${oExtra.name}` }}</p>
          <p>({{ Utils.convertMoney(oExtra.getPrice() || oExtra.price) }})</p>
        </div>
      </div>

      <!-- Borda -->
      <div class="mt_10" v-if="oItem.edges && oItem.edges.length > 0">
        <p class="product-label">{{ StringLanguage.edge }}</p>
        <div
          v-for="(oEdge, iEdge) in oItem.edges"
          :key="iEdge"
          class="label-itens"
        >
          <p>{{ `${oEdge.name}` }}</p>
          <p>({{ oEdge.getPrice && Utils.convertMoney(oEdge.getPrice()) }})</p>
        </div>
      </div>

      <!-- Comentário -->
      <div class="mt_10" v-if="oItem.observation">
        <p class="product-label">{{ StringLanguage.observation }}</p>
        <p class="label-itens">{{ oItem.observation }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '@/utils';
import BaseInputSpinner from '@/components/InputSpinner';
import BaseMessage from '@/components/Message';

export default {
  data() {
    return {
      Utils,
      error: { type: Boolean, default: false },
    };
  },
  props: {
    items: Array,
    catalog: Object,
    remove: Array,
    cart: { type: Boolean, default: false },
  },
  beforeMount() {
    this.error = false;

    if (!this.items) {
      this.error = true;
      return;
    }
    this.items.forEach((item) => {
      if (!item.getPrice) {
        this.error = true;
      }
    });
  },
  methods: {
    removeItem(index) {
      this.remove.splice(index, 1);
      this.$emit('itemRemoved', index);
    },

    handleItemQuantity(index, quantity) {
      // se diminuir qtd do carrinho para zero, exibe excluir
      if (quantity === 0) {
        this.remove.push(index);
      } else {
        // se estiver exibindo excluir e adicionar quantidade, para de exibir
        if (this.remove.includes(index)) this.remove.splice(index, 1);
      }

      this.$emit('itemQuantity', index, quantity);
    },

    categoryName(item) {
      if (this.catalog) {
        if (item.parent) {
          const category = this.catalog.getItemsByParam('_id', item.parent)[0];
          return category.name || 'Sem Categoria';
        }
        if (item.items && item.items[0].parent) {
          const category = this.catalog.getItemsByParam(
            '_id',
            item.items[0].parent
          )[0];
          return category.name || 'Sem Categoria';
        }
      }

      if (item.categoryName && item.categoryName.length > 0) {
        return item.categoryName;
      }

      if (item.items > 0 && item.items.length > 0) {
        return item.items[0].categoryName || 'Sem Categoria';
      }
      return 'Sem Categoria';
    },

    getFlavorsQuantity(items) {
      return items.reduce((total, flavor) => total + flavor.quantity, 0);
    },

    reduceFlavorFraction(num, den) {
      function gcd(a, b) {
        return b ? gcd(b, a % b) : a;
      }

      const gcdResult = gcd(num, den);
      return `${num / gcdResult}/${den / gcdResult}`;
    },
  },
  computed: {},
  components: {
    BaseInputSpinner,
    BaseMessage,
  },
};
</script>
<style scoped>
.remove-btn {
  color: var(--default);
  cursor: pointer;
  font-size: 1.2em;
  font-weight: bold;
}
.product-details > div:not(:first-child) {
  margin-top: 20px;
}

.product-details > .product:not(:last-child) {
  border-bottom: 1px solid #ffffff12;
  padding-bottom: 20px;
}

.name-n-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  flex: 1;
}

.name-n-price + div {
  margin-top: 30px;
}

.name-box {
  min-height: 14px;
  display: flex;
  margin-left: 15px;
  padding-right: 20px;
  justify-content: center;
  flex-direction: column;
}

.product-name {
  font-size: 1.2em;
  font-weight: bold;
  color: var(--label-primary);
  max-height: 30px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 15px;
}

.product-size {
  font-size: 1.2em;
  font-weight: 400;
  color: #999999;
  margin-top: 8px;
}

.product-price {
  font-size: 1.2em;
  color: #cccccc;
  font-weight: bold;
  white-space: nowrap;
}

.product-label {
  font-size: 1.2em;
  line-height: 15px;
  font-weight: bold;
  color: #cccccc;
  text-transform: uppercase;
}

.label-itens {
  font-size: 1.2em;
  font-weight: 400;
  color: #aaaaaba6;
  margin-top: 5px;
  line-height: 15px;
  display: flex;
  word-break: break-word;
}

.label-itens p:last-child {
  margin-left: 5px;
}

.qty-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
  border: 1px solid #bbb;
  padding: 2px;
  border-radius: 5px;
}

.qty-plus,
.qty-minus {
  background: #e3e3e3;
  color: #777;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.qty-qty {
  margin: 0 10px;
}

.qty-no-cart {
  height: 25px;
  padding: 0 10px;
  background: #695f56;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c9c9c9;
  font-weight: bold;
  font-size: 1.2em;
}
</style>
